import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { IHistoricalSnapshotDto } from "../../../pages/list-page/interface/dto/historical-snapshots.dto";
import { get } from "../../../service/api";

export const getHistoricalSnapshot = (
    listId: number,
    tokens: ITokenPair,
): Observable<Array<IHistoricalSnapshotDto>> =>
    get<Array<IHistoricalSnapshotDto>>(
        `/lists/snapshots/${listId}`,
        undefined,
        tokens,
    );
